import { render, staticRenderFns } from "./procesar.pedido.success.vue?vue&type=template&id=6e44d0b8"
import script from "./procesar.pedido.success.vue?vue&type=script&lang=js"
export * from "./procesar.pedido.success.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports